import type { ReactElement } from 'react'

import { FlowPage } from '@monthio/design-system'
import { ListItem, ListItemText, OrderedList } from '#components/OrderedList'
import { useTranslation } from 'react-i18next'

import { useDemoProfile } from '../../../modulesTemp/shared/useDemoProfile'
import { EskatApiEnvironment } from '../Eskat.types'
import { EskatDummyText } from './EskatDummyText'
import { EskatLogoImage } from './EskatLogoImage'

interface EskatConsentIntroProps {
	environment?: EskatApiEnvironment
}

export const EskatConsentIntro = ({
	environment,
}: EskatConsentIntroProps): ReactElement => {
	const { t } = useTranslation()
	const demoProfile = useDemoProfile()

	return (
		<>
			<FlowPage.Header
				slot={<EskatLogoImage />}
				title={t('consent-eksat-title')}
				description={t('consent-eksat-subtitle')}
			/>
			<OrderedList compact>
				<ListItem>
					<ListItemText compact>
						{t('consent-eksat-openEskatConsentPage-txt')}
					</ListItemText>
				</ListItem>
				<ListItem>
					<ListItemText compact>
						{t('consent-eksat-redirectEskatConsentPage-txt')}
					</ListItemText>
				</ListItem>
			</OrderedList>
			<EskatDummyText
				showDummyText={
					Boolean(environment) &&
					environment !== EskatApiEnvironment.Production &&
					demoProfile === null
				}
			/>
		</>
	)
}
